// extracted by mini-css-extract-plugin
module.exports =  {"message":"bYgwcKXKeFSDtvUljniR","error":"CDPXGazipMWUujAluGPQ","success":"XhG2KEk4sQj5Qtktp5oD","btn":"GdBYn_zIecWXYpPRHdtM","input":"IFlijrkFKBNwzfJJ_MyQ"};